<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 项目管理 / 股票列表 / 编辑股票</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              通道
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="className" class="boxText">
                <option>沪深A股</option>
                <option>京市A股</option>
                <option>港股</option>
                <option>美股</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              币种
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="type" class="boxText">
                <option>cny</option>
                <option>usdt</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              股票名称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              股票编码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="code" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              发布日期
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="buyTime" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              发行价格
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="price" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              产品期限
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="day" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              发行方式
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="issuingMethod" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              所属行业
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="industry" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              发行股数
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="num" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              剩余申购量
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="stock" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              起购股数
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="minBuy" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              申购上限
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="maxBuy" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              限购次数
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="maxInvest" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              日利率
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="lilv" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              中签率（每签最大收益）
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="company" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              序列号
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="number" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              发行市盈率(TTM)
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="issuePriceEarningsRatio" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              发行市盈率(静)
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="issuePriceEarningsRatio1" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              净利润增长率(%)
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="netProfitGrowthRate" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              行业市盈率(%)
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="hysyl" class="boxText"/>
            </td>
          </tr>

          <tr>
            <td class="leftTd">
              一级奖励
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="one" class="boxText"/>%
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              二级奖励
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="two" class="boxText"/>%
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              三级奖励
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="three" class="boxText"/>%
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              是否推荐
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="recommend" class="boxText">
                <option>是</option>
                <option>否</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              金币返还
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="gold" class="boxText"/>
              这里填写金币返还比例，1代表1:1返还
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              返利果
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="rebate" class="boxText">
                <option>是</option>
                <option>否</option>
              </select>

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              返利百分比
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="rebateValue" class="boxText"/>%
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              状态
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="state" class="boxText">
                <option>待申购</option>
                <option>可申购</option>
                <option>待上市</option>
                <option>已上市</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              购买等级
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="buyVip" class="boxText"/>
              特别注意：多个等级使用小写逗号分隔
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              保险比例
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="baoxian" class="boxText"/>%
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              进度
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="jindu" class="boxText"/>%
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              购买人数
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="buyNum" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              联动项目ID
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="bindProject" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              联动金额
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="bindPrice" class="boxText"/>
            </td>
          </tr>
        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="保存" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "AddStock",
  data(){
    return{
      className:"",
      id:0,
      type:"cny",
      name:"",
      code:"",
      buyTime:"",
      price:"",
      day:"",
      issuingMethod:"",
      industry:"",
      num:"",
      stock:"",
      minBuy:"",
      maxBuy:"",
      lilv:"",
      company:"",
      number:"",
      issuePriceEarningsRatio:"",
      issuePriceEarningsRatio1:"",
      netProfitGrowthRate:"",
      hysyl:"",
      maxInvest:"",
      one:"",
      two:"",
      three:"",
      recommend:"是",
      gold:"",
      rebate:"是",
      rebateValue:"",
      state:"待申购",
      buyVip:"",
      baoxian:"",
      jindu:"",
      buyNum:"",
      levelList:[],
      teamLevelList:[],
      bindProject:"",
      bindPrice:""
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    let json=JSON.parse(localStorage.getItem("UPDATEOBJ"))
    console.log(json)
    this.type=json.projectCurreny.toString()
    this.id=json.projectId.toString()
        this.name=json.projectName.toString()
        this.className=json.projectClass.toString()
        this.code=json.projectCode.toString()
        this.buyTime=json.projectBuyTime.toString()
        this.price=json.projectPrice.toString()
        this.day=json.projectDay.toString()
        this.issuingMethod=json.projectIssuingMethod.toString()
        this.industry=json.projectIndustry.toString()
        this.num=json.projectNum.toString()
        this.stock=json.projectStock.toString()
        this.minBuy=json.projectMinBuy.toString()
        this.maxBuy=json.projectMaxBuy.toString()
        this.lilv=json.projectRate.toString()
        this.company=json.projectCompany.toString()
        this.number=json.projectNumber.toString()
        this.issuePriceEarningsRatio=json.projectIssuePriceEarningsRatio.toString()
        this.issuePriceEarningsRatio1=json.projectIssuePriceEarningsRatio1.toString()
        this.netProfitGrowthRate=json.projectNetProfitGrowthRate.toString()
        this.hysyl=json.projectHysyl.toString()
        this.maxInvest=json.projectMaxInvest.toString()
        this.one=json.projectOne.toString()
        this.two=json.projectTwo.toString()
        this.three=json.projectThree.toString()
        this.recommend=json.projectRecommend.toString()
        this.gold=json.projectGold.toString()
        this.rebate=json.projectRebate.toString()
        this.rebateValue=json.projectRebateValue.toString()
        this.state=json.projectState.toString()
        this.buyVip=json.projectBuyVip.toString()
        this.baoxian=json.projectInsuranceRate.toString()
        this.jindu=json.projectSchedule.toString()
        this.buyNum=json.projectBuyPeople.toString()
        this.bindProject=json.projectBindProject.toString()
        this.bindPrice=json.projectBindPrice.toString()
  },
  methods: {
    addAdmin(){
      let that=this
      if(this.name==""){
        toask("请输入股票名称！",6)
        return
      }
      if(this.code==""){
        toask("请输入股票编码！",6)
        return;
      }
      if(this.buyTime==""){
        toask("请输入发布日期！",6)
        return;
      }
      if(this.price==""){
        toask("请输入发行价格！",6)
        return;
      }
      if(this.day==""){
        toask("请输入产品期限！",6)
        return;
      }
      if(this.minBuy==""){
        toask("请输入起购股数！",6)
        return;
      }
      if(this.maxBuy==""){
        toask("请输入申购上限！",6)
        return;
      }
      if(this.maxInvest==""){
        toask("请输入限购次数！",6)
        return;
      }
      if(this.lilv==""){
        toask("请输入日利率！",6)
        return;
      }
      if(this.number==""){
        toask("请输入序列号！",6)
        return;
      }
      if(this.one==""){
        toask("请输入一级奖励！",6)
        return;
      }
      if(this.two==""){
        toask("请输入二级奖励！",6)
        return;
      }
      if(this.three==""){
        toask("请输入三级奖励！",6)
        return;
      }
      if(this.gold==""){
        toask("请输入金币返还系数！",6)
        return;
      }
      if(this.rebateValue==""){
        toask("请输入返利百分比！",6)
        return;
      }
      if (parseInt(this.stock) > parseInt(this.num)){
        toask("剩余申购量不能超过发行总数！",6);
        return;
      }
      loading("请求中")
      let param="buyUser=&baoxian=" + this.baoxian + "&buyNum=" + this.buyNum + "&jindu=" + this.jindu + "&id=" + this.id+"&name=" + this.name + "&code=" + this.code + "&type=股票" +
          "&className="+this.className+"&recommend=" + this.recommend+ "&rebate=" + this.rebate + "&state=" + this.state + "&buyTime=" + this.buyTime + "&price=" + this.price
          + "&anticipateDay=&issuingMethod=" + this.issuingMethod+ "&industry=" + this.industry + "&num=" + this.num + "&minBuy=" +this.minBuy + "" +
          "&maxBuy=" + this.maxBuy + "&stock=" + this.stock+ "&maxInvest=" + this.maxInvest + "&company=" + this.company + "&gold=" + this.gold + "&number=" + this.number
          + "&rebateValue=" + this.rebateValue + "&issuePriceEarningRatio=" + this.issuePriceEarningsRatio + "&issuePriceEarningsRatio1=" + this.issuePriceEarningsRatio1 + "&netProfitGrowthRate=" + this.netProfitGrowthRate + "&hysyl=" + this.hysyl + "&valueAdded=0&" +
          "breakValue=否&lilv=" + this.lilv + "&anticipateLive=&day=" + this.day + "&buyVip=" + this.buyVip + "&one=" + this.one
          + "&two=" + this.two + "&three=" + this.three + "&s1=0&s2=0"+"&bindProject="+this.bindProject+"&bindPrice="+this.bindPrice
      axiosPost(DO_NET_URL+"project/UpdateProject?"+param,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("保存成功",6)
          setTimeout(function (){
            that.$emit("send",'stockList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'stockList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>